import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      d="M21.6763 6.18281H17.717C16.4456 6.18281 15.9463 3.5 14.6372 3.5H8.91872C8.03919 3.5 7.59797 6.18281 6.28012 6.18281H2.32075C1.59216 6.18281 1 6.7849 1 7.52569V19.1571C1 19.8979 1.59216 20.5 2.32075 20.5H21.6792C22.4078 20.5 23 19.8979 23 19.1571V7.52569C22.9971 6.7849 22.4078 6.18281 21.6763 6.18281ZM11.9985 18.2628C9.08128 18.2628 6.71843 15.8604 6.71843 12.8943C6.71843 9.92812 9.08128 7.52569 11.9985 7.52569C14.9158 7.52569 17.2787 9.92812 17.2787 12.8943C17.2787 15.8575 14.9129 18.2628 11.9985 18.2628ZM18.3788 8.86858C18.0131 8.86858 17.7199 8.56753 17.7199 8.19861C17.7199 7.82674 18.016 7.52865 18.3788 7.52865C18.7446 7.52865 19.0377 7.82969 19.0377 8.19861C19.0377 8.56753 18.7417 8.86858 18.3788 8.86858ZM5.39768 4.84288C5.39768 4.59497 5.20029 4.39427 4.95646 4.39427H3.6357C3.39187 4.39427 3.19448 4.59497 3.19448 4.84288V5.29149H5.39477C5.39768 5.28854 5.39768 5.08785 5.39768 4.84288ZM11.9985 8.86858C9.81277 8.86858 8.03919 10.6719 8.03919 12.8943C8.03919 15.1167 9.81277 16.92 11.9985 16.92C14.1843 16.92 15.9579 15.1167 15.9579 12.8943C15.9579 10.6689 14.1843 8.86858 11.9985 8.86858Z"
      fill="currentColor"
    />
  </svg>
);
